import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        // Loading state
        return (
            <div
                className="flex h-screen w-screen items-center justify-center bg-[#0a0a0a]"
                data-testid="auth-loading"
            >
                <div className="flex items-center gap-2 text-zinc-500 text-sm">
                    <span className="h-1.5 w-1.5 rounded-full bg-zinc-400 animate-pulse" />
                    <span>Authenticating</span>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (role && user.role !== role) {
        // Authenticated but wrong role
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
